module.exports = __webpack_public_path__ + "static/media/userEditPencil.5da13704.svg";